import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  padding-top: 70px;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerContent = styled.div`
  padding: 20px 5%;
`;

export const ContainerTable = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  height: 80vh;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;
export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSearch = styled.div`
  display: flex;
  align-items: center;
  width: 70%;
`;

export const Select = styled.select`
  width: 150px;
  height: 40px;
  border: 2px solid ${Variables.colorOrange};
  border-radius: 40px;
`;

export const ContainerHeader = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #000;
  background: ${Variables.colorWhite};
`;

export const ContainFieldHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  width: 25%;
  height: 40px;

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 10px;
    overflow-wrap: break-word;
  }
`;

export const ContainField = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 25%;
  height: 40px;

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 14px;
  }

  @media (max-width: ${Variables.maxMobile}) {
    font-size: 10px;
  }
`;

export const ContainerData = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;

export const ContainerRow = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #000;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;
